import { API_BASE_URL } from '../utils/constants';
import axios from 'axios';

// Create axios connection
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    // Authorization headers here
  },
});

// Generic request function
const fetchData = async (endpoint, filters = {}, method = 'GET', data = null) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();
    const url = queryParams ? `/db/${endpoint}?${queryParams}` : `/db/${endpoint}`;

    const response = await apiClient({
      url,
      method,
      data
    });

    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    return error;
  }
}

const sendEmail = async (method = 'POST', data = null) => {
  try {
    const response = await apiClient({
      url: "/send-email/access-code/",
      method,
      data
    });

    return response;
  } catch (error) {
    console.error('API Error:', error);
    return error;
  }
}

const sendUpload = async (endpoint, method = 'POST', file = null) => {
  try {
    const response = await apiClient({
      url: endpoint,
      method,
      data: file, // Convert file to binary
      headers: {
        "Content-Type": file.type, // Set proper MIME type
        "Accept": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("API Error:", error);
    return error;
  }

}
const callAPI = async (endpoint, method = 'POST', data = null) => {
  try {
    const response = await apiClient({
      url: endpoint,
      method,
      data
    });

    return response;
  } catch (error) {
    console.error('API Error:', error);
    return error;
  }
}

export { apiClient, fetchData, sendEmail, callAPI, sendUpload };